import OrganisationService from '../../services/organisation.service'
import ConfirmService from '../../services/confirm.service'
import ToastService from '../../services/toast.service'
import {
	SET_ACCOUNT_ORGANISATIONS,
	FILTER_ACCOUNT_ORGANISATIONS,
	SET_PUBLIC_ORGANISATIONS,
	REMOVE_ACCOUNT_ORGANISATION,
	UPDATE_ORGANISATION_STATE,
	ADD_ACCOUNT_ORGANISATION,
	SET_SELECTED_ORGANISATION,
} from './'

const createOrganisation = (payload: any) => {
	return async () => {
		await OrganisationService.createOrganisation(payload).then((response) => {
			if (response.errors) {
				throw new Error(response.errors)
			} else {
				return response
			}
		})
	}
}

const updateOrganisation = (organisationId: string, payload: any) => {
	return async (dispatch: any) => {
		await OrganisationService.updateOrganisation(organisationId, payload).then(
			(response) => {
				if (response.errors) {
					throw new Error(response.errors)
				} else {
					dispatch({
						type: ADD_ACCOUNT_ORGANISATION,
						response: response,
					})
				}
			}
		)
	}
}

const setAccountOrganisations = (payload: any, filter: boolean = false) => {
	return async (dispatch: any) => {
		return await OrganisationService.getOrganisations(payload)
			.then((response) => {
				if (!filter) {
					return dispatch({
						type: SET_ACCOUNT_ORGANISATIONS,
						response: response,
					})
				}
				return dispatch({
					type: FILTER_ACCOUNT_ORGANISATIONS,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

const getPublicOrganisations: any = (payload: any) => {
	return async (dispatch: any) => {
		await OrganisationService.getOrganisations(payload).then((response) => {
			dispatch({
				type: SET_PUBLIC_ORGANISATIONS,
				response: response,
			})
		})
	}
}

const setSelectedOrganisationBySlug: any = (slug: string) => {
	return async (dispatch: any) => {
		await OrganisationService.getOrganisationBySlug(slug)
			.then((response) => {
				dispatch({
					type: SET_SELECTED_ORGANISATION,
					response: response,
				})
			})
			.catch(() => {
				dispatch({
					type: SET_SELECTED_ORGANISATION,
					response: null,
				})
			})
	}
}

const updateOrganisationState = (payload: {
	organisationId: string
	state: 0 | 1
}) => {
	const type = payload.state == 1 ? 'activate' : 'deactivate'

	return async (dispatch: any) => {
		await ConfirmService.confirm({
			title: `Are you sure you want to ${type} this organisation?`,
		}).then((result) => {
			if (result.value) {
				return OrganisationService.updateOrganisationState(
					payload.organisationId,
					{ state: payload.state }
				).then((response) => {
					if (response.errors) {
						throw new Error(response.errors)
					}

					ToastService.showSuccess(`Organisation ${type}d`)

					dispatch({
						type: UPDATE_ORGANISATION_STATE,
						response: {
							organisationId: payload.organisationId,
							state: payload.state == 1 ? 'active' : 'inactive',
						},
					})
				})
			}
		})
	}
}

const deleteAccountOrganisation = (payload: { organisationId: string }) => {
	return async (dispatch: any) => {
		await ConfirmService.confirm({
			title: 'Are you sure you want to delete this user?',
			customClass: {
				confirmButton: 'bg-red-500 text-white mr-4',
				cancelButton: 'bg-gray-200 text-gray-800',
			},
		}).then((result) => {
			if (result.value) {
				return OrganisationService.deleteOrganisation(
					payload.organisationId
				).then(() => {
					dispatch({
						type: REMOVE_ACCOUNT_ORGANISATION,
						response: { organisationId: payload.organisationId },
					})

					ToastService.showSuccess('Organisation deleted')
				})
			}
		})
	}
}

const updateOrganisationUsers = (organisationId: string, payload: any) => {
	return async () => {
		return await OrganisationService.updateOrganisationUsers(
			organisationId,
			payload
		)
	}
}

export {
	createOrganisation,
	updateOrganisation,
	setAccountOrganisations,
	updateOrganisationUsers,
	updateOrganisationState,
	deleteAccountOrganisation,
	getPublicOrganisations,
	setSelectedOrganisationBySlug,
}
